class MFRHeader {
  constructor(index, element) {
    this.$element = $(element);
    this.selectors = {
      megaMenu: "[data-mega-menu]",
      trigger: "[data-trigger]",
      wrapper: ".header__mega-menu-wrapper",
      megaMenuWrapper: ".mega-menu",
      headerShopifySection: ".shopify-section#shopify-section-header",
      megaMenuLi: ".header-menu__item--has-mega-menu",
      megaMenuSidePanel: ".has-side-panel",
      mainNav: ".mega-menu__main-nav li",
    };

    this.timeoutOffset = 100;

    this.initialize();
  }

  initialize() {
    this.$megaMenu = this.$element.find(this.selectors.megaMenu);
    this.$wrapper = this.$element.find(this.selectors.wrapper);
    this.$section = this.$element.closest(this.selectors.headerShopifySection);
    this.$mainNav = this.$element.find(this.selectors.mainNav);

    this.initMegaMenu();
  }

  initMegaMenu() {
    this.initFocusEvents();
    this.sidePanelFocusEvents();
  }

  moveMegaMenu() {
    this.$megaMenu.each((i, e) => {
      $(e).prependTo(this.$wrapper);
    });
  }

  initFocusEvents() {
    let focusTimeout;
    const li = $(this.selectors.megaMenuLi);

    li.on("focusout mouseout", (e) => {
      focusTimeout = setTimeout(() => {
        $(e.currentTarget).removeClass("is-opened");
        this.$section.removeClass("mega-opened");
      }, this.timeoutOffset);
    });
    li.on("focusin mouseover", (e) => {
      clearTimeout(focusTimeout);
      $(e.currentTarget).addClass("is-opened");
      this.$section.addClass("mega-opened");
    });
  }

  sidePanelFocusEvents() {
    let focusTimeout;
    const $parentMenu = $(this.selectors.megaMenuWrapper);
    const $hasSidePanel = $(this.selectors.megaMenuSidePanel);

    $hasSidePanel.on("focusout mouseout", (e) => {
      focusTimeout = setTimeout(() => {
        $parentMenu.removeClass("is-opened--side-panel");
      }, this.timeoutOffset);
    });

    $hasSidePanel.on("focusin mouseover", (e) => {
      clearTimeout(focusTimeout);
      $parentMenu.addClass("is-opened--side-panel");
    });
  }

  adaptiveMobileMenuBG() {
    const firstSectionBGColor = $(
      "main .shopify-section:first-child > section .background"
    ).css("backgroundColor");
    const $headerSection = $(".shopify-section #header .header__wrapper-inner");

    if (
      firstSectionBGColor == "rgba(0, 0, 0, 0)" ||
      firstSectionBGColor == "transparent"
    )
      return;

    if (matchMedia("screen and (max-width: 1024px)").matches) {
      $headerSection.css("background", firstSectionBGColor);
    } else {
      $headerSection.css("background", "var(--header-background)");
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

class MFRHeaderMobile {
  constructor(e) {
    this.$element = $(e);

    this.selectors = {
      hamburger: ".mobile-menu-trigger",
      wrapper: ".mobile-menu",
      megaMenuWrapper: ".header__mega-menu-wrapper",
      accordionTitle: ".mobile-menu__accordion-title",
      accordionItem: ".mobile-menu__accordion-item",
      menu: ".mobile-menu__accordion-menu",
      cta: ".mobile-menu__cta",
    };

    this.init();
  }

  init() {
    this.$hamburger = this.$element.find(this.selectors.hamburger);
    this.$wrapper = $("body").find(this.selectors.wrapper);
    this.$megaMenu = this.$element.find(this.selectors.megaMenuWrapper);

    this.$hamburger.on("click", this.__handleBurgerClick.bind(this));

    this.initMobileMenu();
  }

  __handleBurgerClick(e) {
    if (this.$hamburger.attr("aria-expanded") == "false")
      this.mobileMenuAnimation.play();
    else this.mobileMenuAnimation.reverse();

    this.$hamburger.attr(
      "aria-expanded",
      this.$hamburger.attr("aria-expanded") == "false" ? "true" : "false"
    );
  }

  initMobileMenu() {
    this.$megaMenu.append(this.$wrapper);
    this.$element
      .find(`${this.selectors.accordionTitle}[data-accordion-item]`)
      .on("click", (e) => e.preventDefault());

    this.mobileMenuAnimation = gsap.timeline({
      paused: true,
    });

    this.mobileMenuAnimation.to(this.$wrapper, {
      scaleY: 1,
      ease: this.ease,
      duration: 0.4,
    });
  }
}